// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BmiGaugeController from "./bmi_gauge_controller"
application.register("bmi-gauge", BmiGaugeController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChannelsController from "./channels_controller"
application.register("channels", ChannelsController)

import ChatInputController from "./chat_input_controller"
application.register("chat-input", ChatInputController)

import CompanionLoadingController from "./companion_loading_controller"
application.register("companion-loading", CompanionLoadingController)

import CompanionPromptSuggestionsController from "./companion_prompt_suggestions_controller"
application.register("companion-prompt-suggestions", CompanionPromptSuggestionsController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import CueCountdownController from "./cue_countdown_controller"
application.register("cue-countdown", CueCountdownController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import GearController from "./gear_controller"
application.register("gear", GearController)

import Guests__AgencyLandingController from "./guests/agency_landing_controller"
application.register("guests--agency-landing", Guests__AgencyLandingController)

import Guests__CoachLandingController from "./guests/coach_landing_controller"
application.register("guests--coach-landing", Guests__CoachLandingController)

import Guests__DodecahedronController from "./guests/dodecahedron_controller"
application.register("guests--dodecahedron", Guests__DodecahedronController)

import Guests__OnboardingFormController from "./guests/onboarding_form_controller"
application.register("guests--onboarding-form", Guests__OnboardingFormController)

import Guests__SwipeDecksController from "./guests/swipe_decks_controller"
application.register("guests--swipe-decks", Guests__SwipeDecksController)

import HomeController from "./home_controller"
application.register("home", HomeController)

import HomeTrainerRevealController from "./home_trainer_reveal_controller"
application.register("home-trainer-reveal", HomeTrainerRevealController)

import LocaleSelectorController from "./locale_selector_controller"
application.register("locale-selector", LocaleSelectorController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import MapController from "./map_controller"
application.register("map", MapController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import QuickReplyController from "./quick_reply_controller"
application.register("quick-reply", QuickReplyController)

import RedirectCountdownController from "./redirect_countdown_controller"
application.register("redirect-countdown", RedirectCountdownController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import Tasks__DigitSpanController from "./tasks/digit_span_controller"
application.register("tasks--digit-span", Tasks__DigitSpanController)

import TeamFilterController from "./team_filter_controller"
application.register("team-filter", TeamFilterController)

import ToggleSubmitBtnController from "./toggle_submit_btn_controller"
application.register("toggle-submit-btn", ToggleSubmitBtnController)

import Utilities__FeatureTourController from "./utilities/feature_tour_controller"
application.register("utilities--feature-tour", Utilities__FeatureTourController)

import Utilities__GeolocationController from "./utilities/geolocation_controller"
application.register("utilities--geolocation", Utilities__GeolocationController)

import Utilities__LongPressController from "./utilities/long_press_controller"
application.register("utilities--long-press", Utilities__LongPressController)

import Utilities__NotificationsProfileController from "./utilities/notifications_profile_controller"
application.register("utilities--notifications-profile", Utilities__NotificationsProfileController)

import Utilities__PwaInstallController from "./utilities/pwa_install_controller"
application.register("utilities--pwa-install", Utilities__PwaInstallController)

import Utilities__UploadOverlayController from "./utilities/upload_overlay_controller"
application.register("utilities--upload-overlay", Utilities__UploadOverlayController)

import WebpushController from "./webpush_controller"
application.register("webpush", WebpushController)
